import { connect } from 'react-redux';

import { actionCreators as orgActionCreators } from 'dux/org';
import { selectors as userSelectors, actionCreators as userActionCreators } from 'dux/user';
import OrgImpersonationPage from './OrgImpersonationPage';

const mapStateToProps = (state) => ({
  user: userSelectors.getIdentityState(state),
});

const mapDispatchToProps = {
  impersonateOrg: userActionCreators.impersonateOrg,
  stopOrgImpersonation: userActionCreators.stopOrgImpersonation,
  getOrg: orgActionCreators.getOrg,
};

export default connect(mapStateToProps, mapDispatchToProps)(OrgImpersonationPage);
